import { render, staticRenderFns } from "./verifyEmail.vue?vue&type=template&id=c6b1778c&scoped=true"
import script from "./verifyEmail.vue?vue&type=script&lang=js"
export * from "./verifyEmail.vue?vue&type=script&lang=js"
import style0 from "./verifyEmail.vue?vue&type=style&index=0&id=c6b1778c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b1778c",
  null
  
)

export default component.exports